/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'company-hub.section-extension.config-panel.background-color-field.background-color': 'Cor do plano de fundo',
  'company-hub.section-extension.config-panel.content-width-field.full-label': 'Completo',
  'company-hub.section-extension.config-panel.content-width-field.full-tooltip': 'Largura total',
  'company-hub.section-extension.config-panel.content-width-field.label': 'Largura do conteúdo',
  'company-hub.section-extension.config-panel.content-width-field.narrow-label': 'Estreito',
  'company-hub.section-extension.config-panel.content-width-field.narrow-tooltip': 'Estreito',
  'company-hub.section-extension.config-panel.content-width-field.wide-label': 'Largo',
  'company-hub.section-extension.config-panel.content-width-field.wide-tooltip': 'Largo',
  'company-hub.section-extension.config-panel.preamble': 'Organize elementos em seções personalizáveis. {supportLink}',
  'company-hub.section-extension.config-panel.preamble-link.label': 'Saiba mais sobre como projetar seu hub.',
  'company-hub.section-extension.config-panel.preamble-without-support-link':
    'Organize os elementos relacionados em seções com planos de fundo e estilos personalizáveis.',
  'company-hub.section-extension.config-panel.title': 'Seção',
  'company-hub.section-extension.error-loading-content': 'Erro ao carregar conteúdo',
  'company-hub.section-extension.manifest.content.header': 'Dê um título à seção',
  'company-hub.section-extension.manifest.content.placeholder-title': 'Espaço reservado',
  'company-hub.section-extension.manifest.content.sub-header':
    'Organize elementos em seções com planos de fundo personalizáveis.',
  'company-hub.section-extension.manifest.extension-lozenge-title': 'Seção',
  'company-hub.section-extension.manifest.extension-title': 'Seção [nova]',
  'company-hub.section-extension.manifest.macro-description': 'Agrupe elementos com um plano de fundo',
};
